import { render, staticRenderFns } from "./ClientHeader.vue?vue&type=template&id=7974f3de&scoped=true&"
import script from "./ClientHeader.vue?vue&type=script&lang=js&"
export * from "./ClientHeader.vue?vue&type=script&lang=js&"
import style0 from "./ClientHeader.vue?vue&type=style&index=0&id=7974f3de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7974f3de",
  null
  
)

export default component.exports